<template>
  <div class="editable-row-component">
    <b-table table-class="text-right" details-td-class="text-right" :items="items" :fields="fields">
      <template #cell(description)>
        <div style="width: 315px">
          <ComboBox
            @loadMoreData="loadMoreProductData"
            @searchedItem="searchProduct($event)"
            :searchedData="productsList"
            @selectedItem="selectProduct($event)"
            @buttonAction="$emit('showModal', $event)"
            classes="w-100"
            :selectedValue="description.value"
            :pagination="true"
            :hasButton="true"
            buttonText="+ شرح جدید"
            itemClass="__item py-2"
            placeholder="شرح فاکتور"
            
          />
        </div>
      </template>
      <template #cell(price)>
        <input class="ui-input" @click="$refs.price.select()" ref="price" type="text" v-model="price" />
      </template>
      <template #cell(count)>
        <input class="ui-input" @click="$refs.count.select()" ref="count" type="text" v-model="count" />
      </template>
      <template #cell(discount)>
        <input class="ui-input" @click="$refs.discount.select()" ref="discount" type="text" v-model="discount" />
      </template>
      <template #cell(totalPrice)>
        <input class="ui-input" @click="$refs.totalPrice.select()" ref="totalPrice" disabled type="text" v-model="totalPrice" />
      </template>
      <template #cell(actions)>
        <div style="height: 30px">
          <div class="d-flex align-items-center h-100 w-100">
            <img style="cursor: pointer" src="@/assets/images/invoice-cancel.svg" @click="deleteInvoice" class="me-2" />
            <img style="cursor: pointer" src="@/assets/images/invoice-check.svg" @click="addDetailToFactor(count, description)" />
          </div>
        </div>
      </template>
    </b-table>
    <Toast title="مورد انتخاب شده تکراری است." error :showToast="duplicateProductSelected" />
    <b-modal v-model="modal.show" centered hide-footer>
      <div class="invoice_error_modal text-center">
        <img class="mb-2" width="70" src="../../../assets/images/exclamation.svg" />
        <p v-if="modal.productError">هیچ کالایی انتخاب نشده است!</p>
        <p v-if="modal.count">تعداد کالا نمیتواند صفر باشد!</p>
        <p v-if="modal.totalPriceError">جمع کل نمیتواند منفی باشد !</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ComboBox from '../../common/form/formModules/ComboBox.vue'
import invoiceDataProvider from '../../../services/invoice'
import { invoiceMixins } from '../../../utils/mixins'
import Toast from '../../common/Toast.vue'

export default {
  name: 'editable-row-component',
  mixins: [invoiceMixins],
  components: {
    ComboBox,
    Toast,
  },
  beforeMount() {
    this.getProducts(this.productDataPagination, 1)
  },
  data() {
    return {
      productLists: null,
      hasNextPage: true,
      fields: [
        { key: 'description', label: 'شرح کالا یا خدمات' },
        { key: 'price', label: 'قیمت' },
        { key: 'count', label: 'تعداد' },
        { key: 'discount', label: 'تخفیف' },
        { key: 'totalPrice', label: 'جمع کل' },
        { key: 'actions', label: '' },
      ],
      addDetail: {
        type: 'detail',
        text: '+ شرح جدید ',
      },
      productDataPagination: {
        pageNumber: 1,
        pageSize: 10,
      },
      items: [{ description: 'description', price: 'price', count: 'count', discount: 'discount', totalPrice: 'totalPrice', actions: 'actions' }],
      price: 0,
      numberPrice: 0,
      count: 0,
      numberDiscount: 0,
      discount: 0,
      description: {},
      id: 0,
      isDuplicate: null,
      selectedRowId: 0,
      editingRow: null,
      modal: {
        show: false,
        productError: false,
        totalPriceError: false,
        count: false,
      },
      duplicateProductSelected: false,
    }
  },
  computed: {
    Row() {
      return this.selectedRow
    },
    totalPrice() {
      return this.calcTotalPrice()
    },
    needsUpdate() {
      return this.updateProductList
    },
    tax() {
      return this.isFormal ? 0.09 : 0
    },
  },
  methods: {
    calcTotalPrice(data) {
      if (data) {
        return 0
      } else {
        let prices = this.count * this.numberPrice
        let priceAfterTax = prices
        let _totalPrice = priceAfterTax - this.numberDiscount
        if (_totalPrice > 0) {
          return _totalPrice.toLocaleString()
        } else {
          return 0
        }
      }
    },
    getProducts(paginationData, type) {
      if (this.hasNextPage) {
        invoiceDataProvider
          .getProducts(paginationData)
          .then(res => {
            this.productLists = res.data.data
            if (this.productLists.length < 10) {
              this.hasNextPage = false
            }
            for (let i = 0; i < this.productLists.length; i++) {
              this.productLists[i].value = this.productLists[i]['name']
              this.productLists[i].key = this.productLists[i]['productId']
              delete this.productLists[i].name
              delete this.productLists[i].productId
            }
            if (type === 1) {
              this.setNewProductList(this.productLists)
            } else if (type === 2) {
              this.setSearchedProductList(this.productLists)
            } else if (type === 3) {
              this.setPaginationProductList(this.productLists)
            }
          })
          .catch(err => {
            
          })
      }
    },
    setEditableRowValues(item) {
      
      this.description = item.find(el => el.fieldName === 'Product:ProductName')
      this.count = item.find(el => el.fieldName === 'Count').value.toLocaleString()
      this.price = parseInt(item.find(el => el.fieldName === 'UnitPrice').value).toLocaleString()
      this.numberPrice = parseInt(this.price.split(',').join(''))
      this.discount = parseInt(item.find(el => el.fieldName === 'Discount').value).toLocaleString()
      this.numberDiscount = parseInt(this.discount.split(',').join(''))
      
    },
    addDetailToFactor(count, description) {
      this.modal.show = false
      this.modal.count = false

      if (count === 0) {
        this.modal.count = true
        this.modal.show = true
        return
      }
      let totalpriceNum

      if (this.description !== '') {
        totalpriceNum = this.totalPrice.split(',').join('')

        if (totalpriceNum < 0) {
          this.modal.productError = false
          this.modal.show = true
          this.modal.totalPriceError = true
          return
        }

        let _discount = this.numberDiscount
        let _price = this.numberPrice
        

        let obj = {
          id: 0,
          items: [
            {
              fieldName: 'Product:ProductName',
              value: description.value,
              typeEnum: 0,
              type: 'Text',
            },
            {
              fieldName: 'Count',
              value: Number(count),
              typeEnum: 1,
              type: 'Text',
            },
            {
              fieldName: 'UnitPrice',
              value: Number(_price),
              typeEnum: 0,
              type: 'Price',
            },
            {
              fieldName: 'ProductsTotalPrice',
              value: Number(count * _price),
              typeEnum: 0,
              type: 'Price',
            },
            {
              fieldName: 'Discount',
              value: Number(_discount),
              typeEnum: 0,
              type: 'Price',
            },
            {
              fieldName: 'TotalPriceAfterDiscount',
              value: parseInt(totalpriceNum),
              typeEnum: 0,
              type: 'Price',
            },
            {
              fieldName: 'TotalTaxCost',
              value: parseInt(this.tax * parseInt(totalpriceNum)),
              typeEnum: 0,
              type: 'Price',
            },
            {
              fieldName: 'TotalPriceAfterDiscountAndTax',
              value: parseInt(totalpriceNum) + parseInt(this.tax * parseInt(totalpriceNum)),
              typeEnum: 0,
              type: 'Price',
            },

            {
              fieldName: 'Product:ProductId',
              type: 'Hidden',
              value: this.selectedProduct ? this.selectedProduct.key : this.editingRow.items.find(e => e.fieldName === 'Product:ProductId').value,
            },
            {
              fieldName: 'Product:ProductStockId',
              type: 'Hidden',
              value: this.selectedProduct ? this.selectedProduct.stockId : this.editingRow.items.find(e => e.fieldName === 'Product:ProductStockId').value,
            },
          ],
        }

        if (this.isDuplicate) {
          
          
        
          this.$nextTick(() => {
            this.editInvoiceList({ id: this.editingRow.id, items: obj.items, index: this.selectedRow.index })

            this.setEditedInvoiceItems(this.editingRow.id)

            this.calcTotalPrice(true)
            this.flushInputFields()
            this.isDuplicate = false
          })
          this.setUpdatedInvoiceList(this.invoiceList)
        } else {
          if (this.description !== '' && totalpriceNum > 0) {
            this.setInvoiceList({ ...obj })

            this.flushInputFields()
          }
        }
        
      } else {
        this.modal.totalPriceError = false
        this.modal.show = true
        this.modal.productError = true
      }
    },
    deleteInvoice() {
      if (this.invoiceList.length > 0) {
        this.isDuplicate = false

        const filterdInvoice = this.editingRow.id ? this.invoiceList.find(invoice => invoice.id == this.editingRow.id) : this.invoiceList[this.selectedRow.index]

        const updatedList = this.invoiceList.filter(invoice => invoice != filterdInvoice)

        this.setUpdatedInvoiceList(updatedList)

        this.setDeletedInvoiceItems(filterdInvoice.id)

        this.setSelectedRow(null)
      }

      this.setSelectedRow(null)
      this.flushInputFields()
    },
    selectProduct(product) {
      this.flushInputFields()
      this.description = product
      // product.name = product['value']
      // product.productId = product['key']
      // delete product.value
      // delete product.key
      this.setSelectedProduct(product)
      
      
      let temp = this.invoiceList.map(invoice => invoice.items)
      this.count = 1
      for (let i = 0; i < temp.length; i++) {
        let findedProduct = temp[i].find(e => e.fieldName === 'Product:ProductId')
        let findedStock = temp[i].find(e => e.fieldName === 'Product:ProductStockId')
         
      
        if (findedProduct.value == this.selectedProduct.key && findedStock.value == this.selectedProduct.stockId) {
          this.duplicateProductSelected = true
          this.setSelectedProduct(null).then(()=>{
            this.flushInputFields()
          })
          setTimeout(() => {
            this.duplicateProductSelected = false
          }, 500)

          return
        }
      }
      invoiceDataProvider
        .getProductPrice({
          productId: product.key,
        })
        .then(res => {
          this.numberPrice = res.data.data

          this.price = Number(res.data.data).toLocaleString()

          this.description = product
        })
        .catch(err => {
          
        })
    },
    searchProduct(searchedValue) {
      this.hasNextPage = true
      this.productDataPagination.query = searchedValue
      this.productDataPagination.pageNumber = 1
      this.getProducts(this.productDataPagination, 1)
    },
    flushInputFields() {
      this.price = 0
      this.discount = 0
      this.count = 0
      this.description = {}
      this.numberPrice = 0
      this.numberDiscount = 0
    },
    loadMoreProductData() {
      if (this.productsList.length <= this.productDataPagination.pageNumber) {
        this.getProducts(this.productDataPagination, 1)
      } else {
        this.productDataPagination.pageNumber += 1
        this.getProducts(this.productDataPagination, 3)
      }
    },
  },
  watch: {
    Row(selectedRow) {
      this.setEditableRowValues(selectedRow.row.items)
      

      this.editingRow = selectedRow.row

      this.isDuplicate = true
    },
    needsUpdate(val) {
      if (val === true) {
        this.productDataPagination.pageNumber = 1
        this.productDataPagination.getSearchSuggestionsQuery = ''
        this.getProducts(this.productDataPagination, 1)
      }
    },
    price(val) {
      if (val !== 0) {
        let _value = val.replace(/\D/g, '')
        this.numberPrice = _value
        this.price = Number(_value).toLocaleString()
      } else {
        this.numberPrice = 0
      }
    },
    discount(val) {
      if (val !== 0) {
        let _value = val.replace(/\D/g, '')
        this.numberDiscount = _value
        this.discount = Number(_value).toLocaleString()
      }
    },
    // count(val) {
    //   if (val !== 0) {
    //     let _value = val.replace(/\D/g, '')
    //     this.count = Number(_value)
    //   }
    // },
  },
}
</script>

<style scoped lang="scss">
::v-deep .close {
  display: none;
}
::v-deep .alert-dismissible {
  padding: 0 !important;
}
::v-deep .alert {
  padding: 0 !important;
}
.invoice_error_modal p {
  margin: 0;
  font-size: 14px;
}

input {
  width: 100%;
  color: #74788d;
  background: #ffffff;
  border: 1px solid #ced4da;
  padding: 6px 10px;
  box-sizing: border-box;
  border-radius: 4px;
}
input:focus {
  outline: none;
}
input:focus::placeholder {
  color: transparent;
}
input::placeholder {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  text-align: right;
  color: #74788d;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

::v-deep td {
  padding: 4px !important;
}
::v-deep thead {
  background-color: rgba(248, 249, 250, 1) !important;
}
</style>
